import { useEffect, useState } from "react";
import { MdArrowForward } from "react-icons/md";
import ModelButton from "../../modelBtn/modelButton";
import { PropTypes } from 'prop-types';

const ShowPopUp = ({ title, children }) => {

    const [modalOpen, setModalOpen] = useState(false);



    const closed = () => setModalOpen(false);
    const open = () => setModalOpen(true);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (modalOpen) {

                document.getElementsByClassName("accordion")[0]?.classList.remove("z-[1]");
            } else {
                document.getElementsByClassName("accordion")[0]?.classList.add("z-[1]");
            }
        }
    }, [modalOpen])





    return (
        <>
            <button
                type="button"
                onClick={
                    () => (modalOpen ? closed() : open())
                }
                className="flex items-center gap-5 text-[1rem] text-[#0039CB] font-bold">
                <h2 className=" ">{title}</h2>
                <MdArrowForward />
            </button>
            <ModelButton modalOpen={modalOpen} close={closed}>

                {children}

            </ModelButton>
        </ >
    )
}
ShowPopUp.propTypes = {
    title: PropTypes.string,
    children: PropTypes.any
}
export default ShowPopUp